import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class, _class2, _temp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
var TableRowCell = (_dec = connect(function (state) {
  return {
    organization: state.organization.current,
    theme: state.theme
  };
}, {}), _dec(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  _inherits(TableRowCell, _Component);

  var _super = _createSuper(TableRowCell);

  function TableRowCell() {
    _classCallCheck(this, TableRowCell);

    return _super.apply(this, arguments);
  }

  _createClass(TableRowCell, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("td", {
        style: this.props.style
      }, this.props.children);
    }
  }]);

  return TableRowCell;
}(Component), _defineProperty(_class2, "defaultProps", {
  style: {}
}), _temp)) || _class);
export default TableRowCell;